import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #2d3436;
  color: white;
  padding: 4rem 2rem 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #6c5ce7;
    }
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 0.8rem;
      
      a {
        color: #ddd;
        text-decoration: none;
        transition: color 0.3s ease;
        
        &:hover {
          color: #6c5ce7;
        }
      }
    }
  }
  
  p {
    color: #ddd;
    line-height: 1.6;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #444;
    color: white;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #6c5ce7;
      transform: translateY(-3px);
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #444;
  color: #aaa;
  font-size: 0.9rem;
`;

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <FooterContainer>
            <FooterContent>
                <FooterSection>
                    <h3>About Us</h3>
                    <p>
                        Our clan website is dedicated to preserving our heritage,
                        connecting clan members, and celebrating our shared history
                        and accomplishments across generations.
                    </p>
                    <SocialLinks>
                        <a href="https://www.facebook.com/groups/1216242120490393/" aria-label="Facebook">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="#" aria-label="Instagram">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="#" aria-label="Twitter">
                            <i className="fab fa-twitter"></i>
                        </a>
                    </SocialLinks>
                </FooterSection>

                <FooterSection>
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/events">News & Events</Link></li>
                        <li><Link to="/history">Clan History</Link></li>
                        <li><Link to="/heritage">Cultural Heritage</Link></li>
                        <li><Link to="/businesses">Clan Businesses</Link></li>
                    </ul>
                </FooterSection>

                <FooterSection>
                    <h3>Contact</h3>
                    <ul>
                        <li>
                            <a href="mailto:info@mlalazi.family">
                                info@mlalazi.family
                            </a>
                        </li>
                        <li>
                            <a href="tel:+27710590527">
                                +27 71 059 0527 / +263 77 380 5927
                            </a>
                        </li>
                        {/**<li>
                            <address style={{ fontStyle: 'normal', color: '#ddd' }}>
                                123 Clan Lane<br />
                                Hometown, ST 12345
                            </address>
                        </li>**/}
                    </ul>
                </FooterSection>
            </FooterContent>

            <Copyright>
                <p>&copy; {currentYear} Mlalazi Clan. All rights reserved.</p>
                <p>Designed by <a href="https://intellommerce.ai"><strong>Intellommerce.ai</strong></a> with ❤️ for the Mlalazi
                    clan</p>
            </Copyright>
        </FooterContainer>
    );
};

export default Footer;